<template>
  <div class="content-container" v-loading="loading">
    <ContentBox title="查看账号" class="content-box">
      <el-form class="cc-form" ref="addForm" :model="addForm" label-width="120px" label-position="left">
        <el-form-item label="登录账号">{{addForm.agentAccount}}</el-form-item>
        <el-form-item label="账号名称">{{addForm.agentAccountName}}</el-form-item>
        <el-form-item label="手机号">{{addForm.phone}}</el-form-item>
        <el-form-item label="邮件地址">{{addForm.email}}</el-form-item>
        <el-form-item label="账号角色">
          <template v-if="addForm.flag === 0">管理员</template>
          <template v-if="addForm.flag === 1">操作员</template>
          <template v-if="addForm.flag === 2">业务员</template>
          <template v-if="addForm.flag === 3">数据员</template>
          <template v-if="addForm.flag === 4">财务</template>
        </el-form-item>
        <el-form-item label="操作客户" class="cc-coll-body-user">
          <span
            v-for="(item, index) in addForm.adDspPartnerEntityList"
            :key="index"
          >{{item.partnerName}} {{index !== addForm.adDspPartnerEntityList.length-1 ? '，' : ''}}</span>
        </el-form-item>
        <el-form-item label="状态">
          <template v-if="addForm.disabled === 0">启用</template>
          <template v-if="addForm.disabled === 1">禁用</template>
        </el-form-item>
      </el-form>
    </ContentBox>
    <ContentBox>
      <el-button @click="handleQuit">
        <i class="icon-ios-undo"></i>返回列表
      </el-button>
    </ContentBox>
  </div>
</template>
<script>
export default {
  props: ['mode', 'id'],
  data() {
    return {
      loading: false,
      addForm: {
        agentAccount: '', // 登录账号
        agentAccountName: '', // 账号名称
        email: '', // 邮箱地址
        phone: '', // 手机号
        flag: 0, // 账号角色
        disabled: 0, // 状态
        adPartnerIdList: [] // 操作客户
      }
    }
  },
  methods: {
    handleQuit() {
      this.$emit('go-back', false)
    },
    getAccAdAgentAccountDetail() {
      this.loading = true
      this.$service
        .getAccAdAgentAccountDetail({ agentAccountId: this.id })
        .then((data) => {
          this.addForm = {
            agentAccount: this.$decrypt(data.agentAccount),
            agentAccountName: data.agentAccountName,
            email: this.$decrypt(data.email),
            phone: this.$decrypt(data.phone),
            flag: data.flag,
            disabled: data.disabled,
            adDspPartnerEntityList: data.adDspPartnerEntityList
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  created() {
    if (this.mode === 'read') {
      this.getAccAdAgentAccountDetail()
    }
  }
}
</script>
<style lang="stylus" scoped>
.content-container
  margin 16px
>>>.title
  padding-left 32px
>>>.content-box__main
  margin-left 32px
</style>
